import React, { useState } from 'react';

const Hero = ({ onSearch }) => {
    const [searchLocation, setSearchLocation] = useState('');
    const [searchType, setSearchType] = useState('');
    const [searchPrice, setSearchPrice] = useState('');

    const handleSearch = () => {
        onSearch({
            location: searchLocation,
            type: searchType,
            price: searchPrice
        });
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleSearch();
        }
    };

    return (
        <section id="home" className="hero">
            <div className="hero-overlay"></div>
            <div className="hero-content">
                <div className="container">
                    <h1 className="hero-title">Find Your Dream Property</h1>
                    <p className="hero-subtitle">Discover luxury homes, apartments, and investment opportunities</p>
                    <div className="hero-search">
                        <div className="search-box">
                            <div className="search-item">
                                <i className="fas fa-map-marker-alt"></i>
                                <input 
                                    type="text" 
                                    placeholder="Location" 
                                    value={searchLocation}
                                    onChange={(e) => setSearchLocation(e.target.value)}
                                    onKeyPress={handleKeyPress}
                                />
                            </div>
                            <div className="search-item">
                                <i className="fas fa-home"></i>
                                <select 
                                    value={searchType}
                                    onChange={(e) => setSearchType(e.target.value)}
                                    onKeyPress={handleKeyPress}
                                >
                                    <option value="">Property Type</option>
                                    <option value="apartment">Apartment</option>
                                    <option value="villa">Villa</option>
                                    <option value="townhouse">Townhouse</option>
                                    <option value="penthouse">Penthouse</option>
                                    <option value="office">Office</option>
                                </select>
                            </div>
                            <div className="search-item">
                                <i className="fas fa-dollar-sign"></i>
                                <select 
                                    value={searchPrice}
                                    onChange={(e) => setSearchPrice(e.target.value)}
                                    onKeyPress={handleKeyPress}
                                >
                                    <option value="">Price Range</option>
                                    <option value="0-500000">Up to $500,000</option>
                                    <option value="500000-1000000">$500,000 - $1,000,000</option>
                                    <option value="1000000-2000000">$1,000,000 - $2,000,000</option>
                                    <option value="2000000+">$2,000,000+</option>
                                </select>
                            </div>
                            <button className="search-btn" onClick={handleSearch}>
                                <i className="fas fa-search"></i> Search
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Hero;
